














































import {Vue, Component} from 'vue-property-decorator';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import RadioElement from '@/components/common/RadioElement.vue';
import {addClass, removeClass} from '@/utils/classUtils';
import {popupResize} from '@/utils/ncp';

import {GetMemberGroupsRequest, PutMembersGroupRequest, GroupUpdateType} from 'supporter';

@Component({
  components: {CompSelectBox, RadioElement}
})
export default class GroupUpdate extends Vue {
  // 변경 대상회원
  private memberName: string = '';
  // 회원그룹 선택
  private groupNo = -1;
  private groupList: any[] = [];
  private get groups() {
    let res = [
      {
        value: -1,
        name: this.$t('COMMON_SELECT')
      }
    ];
    if (this.groupList.length > 0) {
      res.push(
        ...this.groupList.map((item: any) => {
          return {
            value: item.no,
            name: item.name
          };
        })
      );
    }

    return res;
  }
  // 추가/삭제 여부
  private updateType = 'ADD';
  private updateTypes = {
    name: 'updateType',
    data: [
      {
        id: 'updateType_ADD',
        value: 'ADD',
        dispaly: 'COMMON_ADD'
      },
      {
        id: 'updateType_REMOVE',
        value: 'REMOVE',
        dispaly: 'COMMON_DELETE'
      }
    ]
  };

  // 변경 사유
  private reason = '';

  private memberNos: number[] = [];

  private async apply() {
    if (this.groupNo === -1) {
      alert(this.$t('MEMBER_POPUP_ALERT_GROUP_NO_NULL'));
      (this.$refs.groupNo as any).focus();
      return;
    }
    if (this.reason.trim() === '') {
      alert(this.$t('MEMBER_POPUP_ALERT_REASON_NULL'));
      (this.$refs.reason as any).focus();
      return;
    }
    if (this.reason.length > 200) {
      alert(this.$t('MEMBER_POPUP_ALERT_REASON_MAX'));
      (this.$refs.reason as any).focus();
      return;
    }

    let request: PutMembersGroupRequest = {
      data: {
        reason: this.reason,
        memberNos: this.memberNos,
        groupNo: this.groupNo,
        updateType: this.updateType as GroupUpdateType
      }
    };

    let {data} = await this.$api.putMembersGroup(request);
    let alertMsg = data.successCount > 0 ? this.$t('MEMBER_POPUP_GROUP_SUCCESS_MSG', [data.successCount]) : '';
    if (data.failCount > 0) {
      alertMsg += this.$t('MEMBER_POPUP_FAIL_MSG', [data.failCount, data.failures[0].reason]) as string;
    }
    alert(alertMsg);

    if (this.$route.query && this.$route.query.callback) {
      $(window.opener.location).attr('href', `javascript:window.${this.$route.query.callback}();`);
    }
    this.cancel();
  }
  private cancel() {
    window.close();
  }
  private async mounted() {
    addClass(document.body, 'popup_small');
    if (this.$route.query) {
      // 변경 대상회원
      this.memberName = sessionStorage.getItem('memberName') as string;

      // 회원그룹 선택
      let request: GetMemberGroupsRequest = {
        params: {
          mallNo: Number(this.$route.query.mallNo)
        }
      };
      let {data} = await this.$api.getMemberGroups(request);
      this.groupList = data;

      this.memberNos = (this.$route.query.memberNumbers as string).split(',').map((item: string) => Number(item));
    }
    this.$nextTick(() => {
      popupResize();
    });
  }

  private beforeDestroy() {
    removeClass(document.body, 'popup_small');
  }
}
